module.exports = __webpack_public_path__ + "static/media/logo-banexcoin-white-middleorange.8998e8f7.svg";